export default class Gravity {
    time = Date.now();
    // 重力加速度
    g = -9.8;
    static g = -9.8;
    // 所处的位置
    position;
    // 运动速度
    speed;
    constructor(config) {
        this.position = config.position;
        this.speed = config.speed;
    }
    /** 根据初始速度计算在空中停留的时间 */
    static getShowTime(speed) {
        return (2 * speed) / Math.abs(this.g);
    }
    static getHeightBySpeed(speed) {
        return speed ** 2 / 2 / this.g;
    }
    update(now) {
        const seconds = (now - this.time) / 1000;
        this.time = now;
        // 根据运动速度和时间更新当前的位置
        this.position.x += seconds * this.speed.x;
        this.position.z += seconds * this.speed.z;
        // 重力加速度求距离 s = vt + 1/2 * a * t^2;
        this.position.y += this.speed.y * seconds + (this.g * seconds ** 2) / 2;
        this.speed.y += this.g * seconds;
    }
    reset(config) {
        this.position = config.position;
        this.speed = config.speed;
        this.time = Date.now();
    }
}
